<template>
  <li class="nav-item">
    <el-tooltip :content="$t('TRAININGS.NAVBAR_TOOLTIP')" placement="bottom">
      <router-link
        :to="{ name: 'Trainings', query: remaining > 0 ? { tab: 'path' } : {} }"
        class="nav-link position-relative"
        :aria-label="$t('TRAININGS.NAVBAR_TOOLTIP')"
      >
        <i class="ni ni-hat-3 ni-2x"></i>
        <span
          v-if="remaining > 0"
          class="badge badge-md badge-circle badge-floating badge-warning border-white"
        >
          {{ remaining }}
        </span>
      </router-link>
    </el-tooltip>

    <modal :show="showWelcome" @close="showWelcome = false">
      <template slot="header">
        <h3 class="modal-title">
          <i class="ni ni-hat-3 text-primary mr-2"></i>
          {{ $t("TRAININGS.WELCOME_TITLE") }}
        </h3>
      </template>
      <p>
        {{
          myPath.must_watch_videos
            ? $t("TRAININGS.WELCOME_TEXT_WATCH")
            : $t("TRAININGS.WELCOME_TEXT")
        }}
      </p>
      <base-progress
        type="primary"
        :value="percent"
        :height="8"
        show-label
        :label="
          $t('TRAININGS.MY_PATH_PROGRESS', {
            completed: myPath.completed,
            total: myPath.total,
          })
        "
      />
      <div class="mt-3">
        <div v-for="(file, index) in myPath.files" :key="file.id">
          <span class="font-weight-bold mr-1">{{ index + 1 }}.</span>
          <span :class="{ 'text-muted': file.completed_at }">{{
            file.name
          }}</span>
          <i
            v-if="file.completed_at"
            class="fa fa-check-circle text-success ml-1"
          ></i>
        </div>
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="showWelcome = false">
          {{ $t("TRAININGS.WELCOME_LATER") }}
        </base-button>
        <base-button type="primary" @click="start">
          {{
            myPath.completed > 0
              ? $t("TRAININGS.WELCOME_CONTINUE")
              : $t("TRAININGS.WELCOME_START")
          }}
        </base-button>
      </template>
    </modal>
  </li>
</template>

<script>
import { mapGetters } from "vuex";

// Once per browser session and user: shown after sign-in, not on every module
// change (each module layout mounts its own navbar). Keyed by user because a
// sign-out keeps the tab's sessionStorage.
function welcomeKey(userId) {
  return `training_welcome_seen_${userId || ""}`;
}

function welcomeAlreadySeen(userId) {
  try {
    return sessionStorage.getItem(welcomeKey(userId)) === "1";
  } catch (error) {
    return false;
  }
}

function markWelcomeSeen(userId) {
  try {
    sessionStorage.setItem(welcomeKey(userId), "1");
  } catch (error) {
    // Private browsing: the welcome may show again on the next module.
  }
}

/**
 * Icône « Formation » de la barre du haut : pastille du nombre d'étapes restantes
 * du parcours et, à la connexion, fenêtre d'accueil tant que le parcours n'est
 * pas terminé.
 */
export default {
  name: "dashboard-navbar-trainings",

  data() {
    return {
      showWelcome: false,
    };
  },

  computed: {
    ...mapGetters({
      me: "profile/me",
      myPath: "trainings/myPath",
      myPathLoaded: "trainings/myPathLoaded",
    }),
    remaining() {
      return this.myPath.total - this.myPath.completed;
    },
    percent() {
      if (!this.myPath.total) {
        return 0;
      }
      return Math.round((this.myPath.completed / this.myPath.total) * 100);
    },
  },

  async created() {
    if (!this.myPathLoaded) {
      try {
        await this.$store.dispatch("trainings/myPath");
      } catch (error) {
        // The badge and the welcome are a bonus: without them the page still works.
        return;
      }
    }
    const userId = this.me?.id;
    if (
      this.remaining > 0 &&
      !welcomeAlreadySeen(userId) &&
      this.$route.name !== "Trainings"
    ) {
      markWelcomeSeen(userId);
      this.showWelcome = true;
    }
  },

  methods: {
    start() {
      this.showWelcome = false;
      this.$router
        .push({ name: "Trainings", query: { tab: "path" } })
        .catch(() => {});
    },
  },
};
</script>
